<script>
  import AddList from "../form/AddList.svelte";
  import Validators from "../../utils/validators";

  let trackingFields = [
    {
      type: "text",
      name: "name",
      label: "Name",
      readonlyValue: true,
      validations: [Validators.required("Name is required")],
    },
    {
      type: "list",
      name: "control_group",
      label: "Control Group",
      readonlyValue: true,
      validations: [Validators.required("Control Group is required")],
    },
    {
      type: "number",
      name: "size",
      label: "Size",
      prefix: "%",
      readonlyValue: true,
      validations: [Validators.required("Size is required")],
    },
  ];

  let trackingData = [
    {
      name: "Partner 1",
      control_group: "Control Group 1",
      size: 10,
    },
    {
      name: "Partner 2",
      control_group: "Control Group 2",
      size: 20,
    },
  ];

  function onAddRow(dataObj) {
    console.log(dataObj)
    const newTrackingDetail = { ...dataObj };
    trackingData.push(newTrackingDetail);
    return trackingData;
  }

  function onDeleteRow(index) {
    console.log(index)

    trackingData.splice(index, 1);
    return trackingData;
  }
</script>

<h1 class="pb-2 text-xl font-bold">Partner</h1>
<AddList
  name="tracking"
  fields={trackingFields}
  data={trackingData}
  {onAddRow}
  {onDeleteRow}
/>
